import { Component, HostListener, OnInit, ViewChild, ChangeDetectorRef, NgZone  } from '@angular/core';
import { Location } from '@angular/common'
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoreService } from 'src/app/core-service/services/core-service.service';
import { TeamWebsiteService } from 'src/app/team-website/services/team-website.service';
import { environment } from 'src/environments/environment';
import { UserType } from '../../model/common.enum.model';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { CustomConfirmDialogueComponent } from '../custom-confirm-dialogue/custom-confirm-dialogue.component';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public isSubMenuVisible: boolean = false;
  public isFixedFooter: boolean = true;
  public url: string = '';
  public user: any = {};
  public UserType = UserType;
  public isAgentUser: Boolean = false;
  public isSuperAdminUser: Boolean = false;
  public isBranchAdminUser: Boolean = false;
  public isOfficeManagerUser: Boolean = false;
  public isSearchedOfficeManagerUser: Boolean = false;
  public isLOBUser: Boolean = false;
  public isDelegateUser: boolean = false;
  public portalSiteDetail: any = {};
  public userRoleObj: any;
  public showAgentInfo = false;
  public showAdminView = false;
  public showLOBView = false;
  public adminAgentSearch = null;
  public isMobileDevice = false;
  public smartMenuSearch = null;
  public isWebsiteAndListingViewed: boolean = false;
  public teamInfo: any = [];
  public searchAgentTeamInfo: any = [];
  public isTeamLeader: boolean = false;
  public isSearchAgentTeamLeader: boolean = false;
  public showCoreAssociationModule: boolean = false;  
  branchAdminOfficeList: any = [];
  officeManagerOfficeList: any = [];
  portalAgentSearch = false;
  @ViewChild('confirmCancelModal', { static: true })
  public confirmCancelModal: CustomConfirmDialogueComponent | any;
  @ViewChild('confirmCancelEmployeeSearchModal', { static: true })
  public confirmCancelEmployeeSearchModal: CustomConfirmDialogueComponent | any;
  @ViewChild('changeOfficeConfirmationModal', { static: true })
  public changeOfficeConfirmationModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('redirectToNewPage', { static: true })
  public redirectToNewPage: SearchUpdateConfirmationComponent | any;
 
  searchAgentInfoForHeader: any;
  officeManagerAgentSearch: any;
  public nonEmployeeEvent = false;
  public employeeSearch = false;
  officeListForOfficeWebsite: any;
  selectedOfficeListForOfficeWebsite: any;
  lastSelectedOfficeListForOfficeWebsite: any;
  redirectToNewPageUrl = '';
  xcelerateUser: boolean = false;
  constructor(
    private cdref: ChangeDetectorRef,
    private zone: NgZone,
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private teamWebsiteService: TeamWebsiteService,
    private coreService: CoreService,
    private cdr: ChangeDetectorRef,
    private location: Location) {      
    this.router.events.subscribe((event) => {  
      if (this.commonService.getPopState() && this.url === '/portal') {
        this.commonService.setPopState(false);
        if(event instanceof NavigationStart){
          if(this.commonService.isAgentUser() || this.commonService.isOfficeManagerUser()){
            location.replaceState('/portal/personal-info/photos');
            this.router.navigate(['/portal/personal-info/photos']);
          }
          else{
            location.replaceState('/portal');
            this.router.navigate(['/portal']);
          }
        }
      }
      
      if (event instanceof NavigationEnd) {
        this.url = event.url;    
        if(this.url !== '/' && this.url !== '/portal')
          sessionStorage.setItem('currentUrl', this.url);
        
        this.xcelerateUser = this.commonService.getIsXcelerateRedirect();
        if (this.url === '/portal' && (!this.commonService.getIsXcelerateRedirect() && !this.commonService.getPortalFromCore()
          && !this.commonService.getGotoCoreServiceFromPortal() && !this.commonService.getClickNonEmployeeEvent()
          && this.commonService.isSuperAdminUser() || this.commonService.isBranchAdminUser())) {
          this.showAdminView = true;
          this.showAgentInfo = false;
          this.adminAgentSearch = null;
          this.showCoreAssociationModule = false;
          this.nonEmployeeEvent = false;
          this.employeeSearch = false;
          if (this.commonService.isMobileDevice()) {
            this.commonService.setLastAgentSearchDetails(null)
          }
          sessionStorage.removeItem('currentUrl');
          sessionStorage.removeItem('adminSearchData');
          sessionStorage.removeItem('coreServiceFromPortal');
        }
        else if (this.commonService.getPopState() 
            && (this.commonService.isSuperAdminUser() || this.commonService.isBranchAdminUser() || (!this.commonService.isBranchAdminUser() && !this.commonService.getOfficeManagerAgentSitesClick()))
            && (this.commonService.getGotoCoreServiceFromPortal()
            || this.commonService.getHomePageFlag())) {
          this.url = '/portal';
          this.showAdminView = true;
          this.showAgentInfo = false;
          this.adminAgentSearch = null;
          this.showCoreAssociationModule = false;
          this.nonEmployeeEvent = false;
          this.employeeSearch = false;
          if (this.commonService.isMobileDevice()) {
            this.commonService.setLastAgentSearchDetails(null)
          }       
          location.replaceState(this.url);   
          this.commonService.goToCoreServiceFromPortal(false);
          sessionStorage.removeItem('currentUrl');
          sessionStorage.removeItem('adminSearchData');
          sessionStorage.removeItem('coreServiceFromPortal');
        } else if (this.url === '/portal' && this.commonService.getOfficeManagerAgentSitesClick()) {
          this.officeManagerAgentSearch = true;
          this.showAdminView = true;
          this.showAgentInfo = false;
          this.getOfficeNumber(this.userRoleObj.siteUserType, 'officeManager');
          sessionStorage.removeItem('currentUrl');
          sessionStorage.removeItem('adminSearchData');
          sessionStorage.removeItem('coreServiceFromPortal');
        } else if ((this.url === '/portal' || sessionStorage.getItem('currentUrl')?.includes('/portal/core-service/')) && this.commonService.getGotoCoreServiceFromPortal()) {
          this.onCoreServiceClick(''); 
        } else if (this.url === '/portal' && this.commonService.getPortalFromCore()) {
          this.onPortalClick(true);
          this.commonService.goToPortalFromCore(false);
        } else if (this.commonService.getPopState() && this.url === '/portal'){
          this.onClear();
        }     
        
        this.commonService.setPopState(false);
        this.coreService.setFormUpdateStatus(false);
        this.authService.urlSubject.next(this.url);
        setTimeout(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 100);      
    }
    });
  }

  ngOnInit(): void {
    this.checkForDeviceType();
    this.spinner.show();
    this.authService.userSubject.subscribe((res: any) => {
      if (res) {
        this.user = res;
        this.commonService.setUserInfo(this.user);
        this.getUserInfo(this.user);
        this.commonService.setAgentNumber(this.user.onPremisesSamAccountName.trimEnd())
        if (parseInt(this.user.onPremisesSamAccountName) && !this.commonService.getIsXcelerateRedirect()) {
          this.getTeamMemberInfo(this.user.onPremisesSamAccountName, false);
        }
      }
    })
    this.commonService.subscribeToAgentView(() => {
      this.adminAgentSearch = this.commonService.getLastSearchAgentDetails();
    })

    this.commonService.subscribeToGoHome(() => {
      this.onHomeClick('')
    });

    this.commonService.subscribeToGoHomeFromCoreModule(() => {
      setTimeout(() => {
        this.onHomeClickFromCoreModule()
      }, 20);
    });

    this.commonService.subscribeToRedirectToNonEmployeeEdit(() => {
      this.addNonEmployee('')
    });


    this.commonService.subscribeToGoPortalSearchFromCoreModule((res: any) => {
      if (res) {
        setTimeout(() => {
          this.onPortalClick(true);
        }, 100);
      }
    });

    this.commonService.subscribeToGoCoreServicesFromHome((res: any) => {
      if (res) {
        this.onCoreServiceClick('')
      }
    });

    this.commonService.subscribeToOfficeManagerAgentSearch((res: any) => {
      if (res && this.commonService.getOfficeManagerAgentSitesClick()) {
        this.officeManagerAgentSearch = true;
        this.showAdminView = true;
        this.showAgentInfo = false;
        this.getOfficeNumber(this.userRoleObj.siteUserType, 'officeManager');
      } else if (res === false) {
        this.spinner.show();
        this.showAgentInfo = true;
        this.showAdminView = false;
        this.getUserInfo(this.user);
        this.isSearchedOfficeManagerUser = false;
        this.commonService.setAgentNumber(this.user.onPremisesSamAccountName.trimEnd())
        this.getTeamMemberInfo(this.user.onPremisesSamAccountName, false);
        this.officeManagerAgentSearch = false;
      }
    })

    this.commonService.subscribeUpdateTeamCount(() => {
      this.getTeamMemberInfo(this.commonService.getAgentNumber(), false);
    });

    this.commonService.subscribeRedirectToNewPage((url: string) => {
      this.redirectToNewPageUrl = url;
      if (this.commonService.getFormUpdateStatus()) {
        this.redirectToNewPage.showModal()
      } else {
        this.redirectToNewPageConfirm();
      }
    })

    this.commonService.delegateUserFlow.subscribe((res: any) => {   
      this.commonService.setAgentNumber(res.Agent_Number);
      this.commonService.startSessionTimer();
      this.getUserInfo(res);
    })

    this.commonService.subscribeInitAdminSearchForm((res: any) => {
      this.onManage();       
    });     
    this.cdr.detectChanges();
  }

  /**
   * Fetches user info
   * @param user 
   */
   getUserInfo(user: any) {
    setTimeout(() => {
      this.commonService.getUserInfo(user).subscribe(
        (response: any) => {
          if (response === null) {
            this.spinner.hide();
            this.router.navigate(['error']);
          } else {
            // Running updates inside Angular's zone
            this.zone.run(() => {
              this.userRoleObj = response;
             this.commonService.setUserRoleObj(response);
  
              if (!this.commonService.getIsXcelerateRedirect()) {
                this.isAgentUser = this.commonService.isAgentUser();
                this.isSuperAdminUser = this.commonService.isSuperAdminUser();
                this.isBranchAdminUser = this.commonService.isBranchAdminUser();
                this.isOfficeManagerUser = this.commonService.isOfficeManagerUser();
                this.isDelegateUser = this.commonService.getIsDelegateLoggedIn();
                this.isLOBUser = this.commonService.isLOBUser();
  
                if (!this.isLOBUser) {
                  if (this.isDelegateUser) {
                    let agentNumber = this.commonService.getDelegateUserInfo()?.Agent_Number;
                    if (agentNumber !== '') {
                      this.getTeamMemberInfo(agentNumber, false);
                    }
                  } else {
                    this.getTeamMemberInfo(this.user.onPremisesSamAccountName, false);
                  }
                }
  
                if (this.isSuperAdminUser || this.isLOBUser || this.isBranchAdminUser) {
                  this.showAdminView = true;
                  this.showAgentInfo = false;
                  this.cdref.detectChanges();
                  this.commonService.agentSearchEmitter.subscribe(() => {
                    this.commonService.responsiveAdminSearchClicked = this.isMobileDevice;
                    if (this.commonService.getFormUpdateStatus()) {
                      this.confirmCancelModal.showModal('Are you sure you want to navigate away from this page?');
                    } else {
                      this.adminAgentSearch = null;
                    }
                  });
  
                  this.commonService.employeeSearchEmitter.subscribe(() => {
                    if (this.commonService.getFormUpdateStatus()) {
                      this.confirmCancelEmployeeSearchModal.showModal('Are you sure you want to navigate away from this page?');
                    } else {
                      this.nonEmployeeEvent = false;
                      this.employeeSearch = false;
                      this.cdref.detectChanges();
                    }
                  });
                } else if (this.isAgentUser || this.isOfficeManagerUser || this.isDelegateUser) {
                  this.showAdminView = false;
                  this.showAgentInfo = true;
                  this.showLOBView = false;
  
                  if (this.isAgentUser || this.isOfficeManagerUser) {
                    this.commonService.setDelegateResponsiveFlag(false);
                  }
  
                  this.commonService.agentSearchEmitter.subscribe(() => {
                    this.commonService.responsiveAdminSearchClicked = this.isMobileDevice;
                    if (this.commonService.getFormUpdateStatus()) {
                      this.confirmCancelModal.showModal('Are you sure you want to navigate away from this page?');
                    } else {
                      this.adminAgentSearch = null;
                      if (this.isMobileDevice && this.isDelegateUser) {
                        this.commonService.setDelegateResponsiveFlag(true);
                      }
                    }
                  });
                }
  
                if (parseInt(user?.onPremisesSamAccountName)) {
                  this.getPortalSiteDetails(user.onPremisesSamAccountName, false);
                } else if (this.isDelegateUser && user.Agent_Number !== '' && !sessionStorage.getItem('currentUrl')) {
                  this.getPortalSiteDetails(user.Agent_Number, false);
                }
  
                if (this.isBranchAdminUser) {
                  this.getOfficeNumber(this.userRoleObj.siteUserType, 'branchAdmin');
                } else {
                  this.spinner.hide();
                }
              } else {
                this.showAdminView = false;
                this.showAgentInfo = true;
                this.cdref.detectChanges();
                if (this.commonService.getXceleratActionType() === '1') {
                  this.router.navigate(['/portal/subscriptions/authentisign']);
                } else if (this.commonService.getXceleratActionType() === '3') {
                  this.router.navigate(['/portal/subscriptions/docusign']);
                } else {
                  this.router.navigate(['/portal/subscriptions']);
                }
              }
            }); // End of this.zone.run block
          }
        },
        (err) => {
          this.spinner.hide();
          this.router.navigate(['error']);
        }
      );
    }, 100);
  }

  /**On click of yes on confirmation popup */
  onConfirmSearch() {
    this.adminAgentSearch = null;
    this.commonService.setFormUpdateStatus(false);
    //this.showAgentInfo = false;
  }

  /**
   * Agent Number has to be passed as input param to the below function to get portal site details
   */
  getPortalSiteDetails(agent: number, agentSearch: boolean): void {
    this.commonService.getPortalSiteDetail(agent).subscribe((res: any) => {
      if (res === null && !this.isBranchAdminUser && !this.isSuperAdminUser) {
        this.spinner.hide();
        this.router.navigate(['error'])
      } else {
        this.portalSiteDetail = res;
        if (this.portalSiteDetail) {      
          sessionStorage.setItem('portalSiteId', this.portalSiteDetail.portalSiteId);
          if ((this.showAgentInfo || this.isOfficeManagerUser || this.isDelegateUser) 
              && (sessionStorage.getItem('currentUrl') === null || sessionStorage.getItem('currentUrl')?.includes('/personal-info/photos'))) {
            this.commonService.setDelegateResponsiveFlag(this.isDelegateUser && this.isMobileDevice);
            this.router.navigate(['/portal/personal-info/photos']);
          }
        }
      }  
      if(sessionStorage.getItem('adminSearchData') 
        && sessionStorage.getItem('officeManagerAgentSearch') === 'true'
        && !this.commonService.getOfficeManagerAgentSitesClick()){
          this.commonService.setOfficeManagerAgentSitesClick(true);
          this.officeManagerAgentSearch = true;
          this.showAgentInfo = true;          
          this.getOfficeNumber(this.userRoleObj.siteUserType, 'officeManager');  
      }
      else if (this.router.url.includes('/portal/personal-info/photos')) {
        this.authService.agentSearchPageRefresh.next(true);
      }
      this.getBasicAgentInfo(agent);
      this.getTeamList(agent);
      this.getOfficeListForOfficeWebsite(agent)
      if (agentSearch) {
        if (res.officeTourRole === 'Office Manager') {
          this.isSearchedOfficeManagerUser = true;
        } else {
          this.isSearchedOfficeManagerUser = false;
        }
        this.getTeamMemberInfo(agent, agentSearch);
      }
      this.spinner.hide();
    }, err => {
      this.spinner.hide()
      // handle error
      this.router.navigate(['error']);
    });
  }

  /* On Manage Action */
  onManage() {
    this.showAgentInfo = true;
    this.showAdminView = false;
    this.adminAgentSearch = null;
    this.showCoreAssociationModule = false;
  }

  /* On Manage Action for core services */
  onCoreManage() {
    this.showAgentInfo = false;
    this.showAdminView = false;
    this.adminAgentSearch = null;
    this.showCoreAssociationModule = true;
    // this.commonService.gotoCoreServicesFromHome.next(true);
  }

  /* On admin search agent */
  onSearch(event: any) {
    this.adminAgentSearch = event;
    this.smartMenuSearch = null;
    this.showCoreAssociationModule = false;
    this.getPortalSiteDetails(event.agentName.id, true)
  }

  /* On admin clear search */
  onClear() {
    this.adminAgentSearch = null;
  }

  /* check for mobile device */
  checkForDeviceType() {
    this.isMobileDevice = this.commonService.isMobileDevice();
  }

  /** personal info menu show */
  public get isPersonalInfoEnabled(): boolean {
    return this.url.includes('/personal-info');
  }

  /** subscriptions menu show */
  public get isSubscriptionEnabled(): boolean {
    return this.url.includes('/portal/subscriptions');
  }

  /** subscriptions menu show */
  public get isTeamWebsiteEnabled(): boolean {
    return this.url.includes('/portal/team-website');
  }

  /** office websites sub menu */
  public get isOfficeWebsiteEnabled(): boolean {
    return this.url.includes('/portal/office-websites') && this.officeListForOfficeWebsite;
  }

  /** leads-crm menu show */
  public get isLeadsEnabled(): boolean {
    return this.url.includes('/portal/leads-crm');
  }


  /* On header logo click */
  showLandingPage() {
    if (this.isSuperAdminUser || this.isLOBUser || this.isBranchAdminUser) {
      this.showAdminView = true;
      this.showAgentInfo = false;
      this.adminAgentSearch = null;
      this.showCoreAssociationModule = false;
      this.nonEmployeeEvent = false;
      this.employeeSearch = false;
      this.commonService.goToCoreServiceFromPortal(false);
      this.router.navigate(['portal']);
    } else if (this.isAgentUser) {
      this.showAdminView = false;
      this.showAgentInfo = true;
      this.showLOBView = false;
    }
  }

  /**
   *on click of Website and Listing menu
   */
  onListSearch(event: any) {
    this.smartMenuSearch = event;
    let listingsUrl = (this.isBranchAdminUser || this.isSuperAdminUser || this.isOfficeManagerUser)
        ? environment.fnisToolsUrlBranchAdminUrl
        : (this.isDelegateUser ? environment.fnisToolsDelegateUrl : environment.fnisToolsUrl);
    window.open(listingsUrl, '_self'); 
  }

  /**
   *on click of Home menu
   */
  onHomeClick(_event: any) {
    this.showAdminView = true;
    this.showAgentInfo = false;
    this.adminAgentSearch = null;
    this.showCoreAssociationModule = false;
    this.nonEmployeeEvent = false;
    this.employeeSearch = false;

  }

  onHomeClickFromCoreModule() {
    this.showCoreAssociationModule = false;
    this.nonEmployeeEvent = false;
    this.employeeSearch = false;
    this.showAdminView = true;
  }

  /**
   *on click of Portal menu
   */
  onPortalClick(_event: any) {
    this.showAdminView = false;
    this.showAgentInfo = true;
    this.showCoreAssociationModule = false;
    this.adminAgentSearch = null;
    this.nonEmployeeEvent = false;
    this.employeeSearch = false;
  }

  /**
 *on click of Core Services menu
 */
  onCoreServiceClick(_event: any) {
    setTimeout(() => {
      this.showAdminView = false;
      this.showAgentInfo = false;
      this.adminAgentSearch = null;
      this.showCoreAssociationModule = true;

    }, 10);
  }

  /**
   * api to get team info details
   */
  public getTeamMemberInfo(id: number, agentSearch: boolean) {
    this.teamWebsiteService.getTeamRole(id).subscribe((res: any) => {
      this.commonService.getLatestTeamRole$.next(res.body);
      this.commonService.setTeamCountObj(res.body);
      if (!agentSearch) {
        this.teamInfo = res.body;
        sessionStorage.setItem('teamName', this.teamInfo?.teamName)
        sessionStorage.setItem('SelectedteamRole', this.teamInfo?.teamRole);
        sessionStorage.setItem('TeamDetails', this.teamInfo?.teamId);
        if (this.teamInfo?.teamRole === "Leader") {
          this.isTeamLeader = true;
        } else if (this.teamInfo?.teamRole === "Member") {
          this.isTeamLeader = false;
        }
      } else {
        this.isTeamLeader = false;
        this.searchAgentTeamInfo = res.body;
        sessionStorage.setItem('AgentTeamName', this.searchAgentTeamInfo?.teamName)
        sessionStorage.setItem('agentSearchSelectedteamRole', this.searchAgentTeamInfo?.teamRole);
        if (this.searchAgentTeamInfo?.teamRole === "Leader") {
          this.isSearchAgentTeamLeader = true;
        } else if (this.searchAgentTeamInfo?.teamRole === "Member") {
          this.isSearchAgentTeamLeader = false;
        }
      }
    });
  }

  /** get offce Numbers */
  getOfficeNumber(siteUserType: number, userType: string) {
    this.spinner.show();
    let param = `UserName=${this.user.userPrincipalName},SiteUserType=${siteUserType}`;
    this.commonService.getOfficeNumer(param).subscribe((res: any) => {

      if (userType === 'officeManager') {
        this.officeManagerOfficeList = res.body !== null ? res.body : [];
      } else {
        this.branchAdminOfficeList = res.body !== null ? res.body : [];
      }

      this.spinner.hide();
    })
  }



  /** get basic info for search agent by super admin */
  getBasicAgentInfo(agent: number) {
    this.commonService.getBasicSearchAgent(agent).subscribe((res: any) => {
      this.commonService.setSearchedAgentInfo(res);
      this.searchAgentInfoForHeader = JSON.parse(JSON.stringify(res));
        this.commonService.fmUser.next(false);
    })
  }


  addNonEmployee(event: any) {
    this.commonService.setClickNonEmployeeEvent(false)
    this.nonEmployeeEvent = true;
    this.router.navigate(['/portal/core-service/nonEmployeeProfile']);
  }

  /** navigate to employee search */
  searchForCoreEmployee(event: any) {
    this.employeeSearch = true;
    if (this.router.url === '/portal/core-service/employeeSearchComponent') {
      this.commonService.updateCoreEmployeeSearch$.next(event);
    } else {
      this.router.navigate(['/portal/core-service/employeeSearchComponent']);
    }

  }

  hideNonEmployee(event: any) {
    this.commonService.setClickNonEmployeeEvent(true);
    this.nonEmployeeEvent = false;
    this.showCoreAssociationModule = true;
    this.employeeSearch = false;
    this.router.navigate(['/portal']);
  }


  onConfirmSearchEmployee() {
    this.nonEmployeeEvent = false;
    this.employeeSearch = false;
    this.commonService.setFormUpdateStatus(false);
  }

  /** get office list for office website menu */
  getOfficeListForOfficeWebsite(id: number) {
    const value = `agentNumber=${id}`
    this.commonService.getOfficeListForOfficeWebsite(value).subscribe((res: any) => {
      if (res && res.body) {
        this.commonService.setOfficeListOfficeWebsite(res.body);
        this.selectedOfficeListForOfficeWebsite = res.body[0].id;
        this.lastSelectedOfficeListForOfficeWebsite = res.body[0].id;
        this.commonService.setterSelectedOfficeWebsite(this.selectedOfficeListForOfficeWebsite);
        this.commonService.selectedOfficeListForOfficeWebsite$.next(this.selectedOfficeListForOfficeWebsite);
        this.officeListForOfficeWebsite = res.body;
      }
    })
  }

  officeChangeEvent(_event: any) {
    if (this.commonService.getFormUpdateStatus()) {
      this.changeOfficeConfirmationModal.showModal();
    } else {
      this.officeChangeEventConfirm();
    }
  }

  officeChangeEventConfirm() {
    this.lastSelectedOfficeListForOfficeWebsite = this.selectedOfficeListForOfficeWebsite;
    this.commonService.setFormUpdateStatus(false);
    this.commonService.selectedOfficeListForOfficeWebsite$.next(this.selectedOfficeListForOfficeWebsite);
    this.commonService.setterSelectedOfficeWebsite(this.selectedOfficeListForOfficeWebsite);
  }

  /** on cancel confirm of navigation popup */
  onCancelConfirmNavigatePopup() {
    this.selectedOfficeListForOfficeWebsite = this.lastSelectedOfficeListForOfficeWebsite;
  }

  /** get team list for agent  */
  getTeamList(agent: number) {
    this.commonService.getTeamList(agent).subscribe((res: any) => {
      this.commonService.setTeamListDetails(res);
    })
  }

  redirectToNewPageConfirm() {
    this.commonService.setFormUpdateStatus(false);
    this.router.navigate([this.redirectToNewPageUrl])
  }
}
